import { useEventBus } from '@vueuse/core';

export interface IKasperskyEvent {
  login_start: () => void;
}

export class KasperskyEvent {
  public static LOADED = useEventBus<IKasperskyEvent>('kaspersky-loaded');

  public static async waitForEvent(): Promise<IKasperskyEvent> {
    const value = await new Promise<IKasperskyEvent>((resolve) => {
      const stop = this.LOADED.on((event) => {
        resolve(event);
        stop();
      });
    });

    return value;
  }

  public static async getKasperskyDeviceTag(): Promise<string> {
    // @ts-expect-error window.kfp
    let kfp = window.kfp;
    if (!kfp) {
      kfp = await KasperskyEvent.waitForEvent();
    }

    return await kfp.login_start();
  }
}